import type RootStore from "stores/RootStore";
import { RouteType } from "types/RouteType";
import type DataMapperSchemasStore from "./DataMapperSchemasStore";
import type DataMapperProfileStateStore from "../DataMapperProfileStateStore";
import { DATA_MAPPER_STEP } from "../DataMapperProfileStateStore";
import { DATA_MAPPER_ROUTE } from "../shared/editorRoutes";

const schemasStore = (rootStore: RootStore) => rootStore.dataMapperSchemasViewStore as DataMapperSchemasStore;
const stateStore = (rootStore: RootStore) =>
  rootStore.dataMapperProfileStateViewStore as DataMapperProfileStateStore;

/**
 * Data Mapper → Schema: the open profile's target schemas, with a TypeBox
 * editor (parsed, never evaluated). Gated like the Profiles route: the store
 * checks `canUseDataMapper` before calling, the API refuses viewers regardless.
 */
const dataMapperSchemasRoute: RouteType[] = [
  {
    name: DATA_MAPPER_ROUTE.schema,
    path: "/data-mapper/schema",
    layout: "/app",
    viewportCard: {
      header: {
        enableBackButton: true,
        title: "Target Schema",
        enableRefreshButton: true,
        component: () => import("../shared/DataMapperEditor.Header"),
      },
      body: {
        component: () => import("./DataMapperSchemas.Body"),
        grayBackground: true,
      },
    },
    group: "Data Mapper",
    searchAliases: ["data mapper schema", "typebox schema", "target schema"],
    requiresAuth: true,
    requiresPermission: false,
    onEnter: ({ rootStore }) => {
      // Read the profile's saved selection first: it may name the schema to show.
      void (async () => {
        await stateStore(rootStore)?.enterStep(DATA_MAPPER_STEP.schema);
        await schemasStore(rootStore)?.load();
      })();
    },
    onExit: ({ rootStore }) => {
      void stateStore(rootStore)?.flush();
      schemasStore(rootStore)?.reset();
    },
  },
];

export default dataMapperSchemasRoute;
